(function () {
  'use strict';

  if (window.MvcPhysicalProduct && typeof window.MvcPhysicalProduct.initScope === 'function') {
    window.MvcPhysicalProduct.initScope(document);
    return;
  }

  var cleanups = new WeakMap();
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function queryAll(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function asNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : (fallback || 0);
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    var amount = (Math.max(0, cents) / 100).toFixed(precision);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }

  function createMoneyFormatter(root) {
    var node = root.querySelector('[data-physical-money-format]');
    var format = '₪{{amount}}';
    if (node) {
      try { format = JSON.parse(node.textContent); } catch (error) { format = node.textContent || format; }
    }
    return function (cents) {
      var token = (format.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
      var value;
      if (token === 'amount_no_decimals') value = formatWithDelimiters(cents, 0, ',', '.');
      else if (token === 'amount_with_comma_separator') value = formatWithDelimiters(cents, 2, '.', ',');
      else if (token === 'amount_no_decimals_with_comma_separator') value = formatWithDelimiters(cents, 0, '.', ',');
      else if (token === 'amount_with_apostrophe_separator') value = formatWithDelimiters(cents, 2, "'", '.');
      else value = formatWithDelimiters(cents, 2, ',', '.');
      return format.replace(/\{\{\s*\w+\s*\}\}/, value);
    };
  }

  function setFeedback(node, message, error) {
    if (!node) return;
    node.textContent = message || '';
    node.classList.toggle('is-error', Boolean(error));
  }

  function cartError(error) {
    if (error && error.message && error.message !== 'cart_request_failed') return error.message;
    return 'לא ניתן לעדכן את העגלה כרגע. נסו שוב.';
  }

  function initPhysical(root) {
    if (!root || root.dataset.physicalInitialized === 'true') return;
    root.dataset.physicalInitialized = 'true';

    var cleanupTasks = [];
    var formatMoney = createMoneyFormatter(root);
    var variantSelect = root.querySelector('[data-physical-variant-select]');
    var form = root.querySelector('[data-physical-form]');
    var quantityInput = root.querySelector('[data-physical-qty]');
    var mainAdd = root.querySelector('[data-physical-add]');
    var mobileAdd = root.querySelector('[data-physical-mobile-add]');
    var feedback = root.querySelector('[data-physical-form-feedback]');
    var optionGroups = queryAll(root, '[data-physical-option-group]');
    var optionButtons = queryAll(root, '[data-physical-option-value]');
    var variants = variantSelect ? Array.prototype.slice.call(variantSelect.options) : [];
    var selectedValues = [];
    var activeVariant = variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null;
    var threshold = asNumber(root.dataset.lowStockThreshold, 6);

    if (form) form.dataset.mvcCartBound = 'true';

    function realStock(option) {
      return Boolean(option && option.dataset.realStock === 'true');
    }

    function variantValue(option, position) {
      return option ? option.dataset['option' + position] || '' : '';
    }

    function syncSelectedValues(option) {
      optionGroups.forEach(function (group) {
        var position = asNumber(group.dataset.optionPosition);
        selectedValues[position - 1] = variantValue(option, position);
      });
    }

    function exactVariant(requireStock) {
      return variants.find(function (option) {
        if (requireStock && !realStock(option)) return false;
        return optionGroups.every(function (group) {
          var position = asNumber(group.dataset.optionPosition);
          return variantValue(option, position) === selectedValues[position - 1];
        });
      }) || null;
    }

    function renderOptionState() {
      optionButtons.forEach(function (button) {
        var position = asNumber(button.dataset.optionPosition);
        var selected = selectedValues[position - 1] === button.dataset.optionValue;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    function renderOptionAvailability() {
      optionGroups.forEach(function (group) {
        var groupPosition = asNumber(group.dataset.optionPosition);
        var buttons = queryAll(group, '[data-physical-option-value]');
        var availability = buttons.map(function (button) {
          return variants.some(function (option) {
            if (!realStock(option) || variantValue(option, groupPosition) !== button.dataset.optionValue) return false;
            return optionGroups.every(function (otherGroup) {
              var otherPosition = asNumber(otherGroup.dataset.optionPosition);
              if (otherPosition === groupPosition || !selectedValues[otherPosition - 1]) return true;
              return variantValue(option, otherPosition) === selectedValues[otherPosition - 1];
            });
          });
        });

        if (!availability.some(Boolean)) {
          availability = buttons.map(function (button) {
            return variants.some(function (option) {
              return realStock(option) && variantValue(option, groupPosition) === button.dataset.optionValue;
            });
          });
        }

        buttons.forEach(function (button, index) {
          button.disabled = !availability[index];
          button.classList.toggle('is-unavailable', !availability[index]);
        });
      });
    }

    var slides = queryAll(root, '[data-physical-slide]');
    var thumbs = queryAll(root, '[data-physical-thumb]');
    var galleryCount = root.querySelector('[data-physical-gallery-count]');
    var activeSlideIndex = Math.max(0, slides.findIndex(function (slide) { return !slide.hidden; }));

    function showSlide(index, scrollThumb) {
      if (!slides.length) return;
      activeSlideIndex = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === activeSlideIndex;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      thumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === activeSlideIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (galleryCount) galleryCount.textContent = (activeSlideIndex + 1) + ' / ' + slides.length;
      if (scrollThumb && thumbs[activeSlideIndex]) {
        thumbs[activeSlideIndex].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reducedMotion ? 'auto' : 'smooth' });
      }
    }

    function showMedia(mediaId) {
      if (!mediaId) return;
      var index = slides.findIndex(function (slide) { return slide.dataset.mediaId === String(mediaId); });
      if (index >= 0) showSlide(index, true);
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { showSlide(index, false); });
    });
    var previous = root.querySelector('[data-physical-gallery-prev]');
    var next = root.querySelector('[data-physical-gallery-next]');
    if (previous) previous.addEventListener('click', function () { showSlide(activeSlideIndex - 1, true); });
    if (next) next.addEventListener('click', function () { showSlide(activeSlideIndex + 1, true); });
    var galleryMain = root.querySelector('.physical-gallery-main');
    var touchStartX = null;
    var touchStartY = null;
    if (galleryMain && slides.length > 1) {
      galleryMain.addEventListener('touchstart', function (event) {
        var touch = event.changedTouches && event.changedTouches[0];
        touchStartX = touch ? touch.clientX : null;
        touchStartY = touch ? touch.clientY : null;
      }, { passive: true });
      galleryMain.addEventListener('touchend', function (event) {
        if (touchStartX === null || !event.changedTouches || !event.changedTouches[0]) return;
        var distance = event.changedTouches[0].clientX - touchStartX;
        var verticalDistance = event.changedTouches[0].clientY - touchStartY;
        touchStartX = null;
        touchStartY = null;
        if (Math.abs(distance) < 45 || Math.abs(distance) <= Math.abs(verticalDistance)) return;
        showSlide(distance < 0 ? activeSlideIndex + 1 : activeSlideIndex - 1, true);
      }, { passive: true });
    }
    if (slides.length) showSlide(activeSlideIndex, false);

    function quantity() {
      if (!quantityInput) return 1;
      var minimum = asNumber(quantityInput.min, 1);
      var maximum = asNumber(quantityInput.max, 99);
      var value = Math.round(asNumber(quantityInput.value, minimum));
      value = Math.min(maximum, Math.max(minimum, value));
      quantityInput.value = String(value);
      return value;
    }

    function renderStock(option) {
      var stock = root.querySelector('[data-physical-stock]');
      var stockValue = root.querySelector('[data-physical-stock-value]');
      if (!stock || !stockValue) return;
      var available = realStock(option);
      var managed = Boolean(option && option.dataset.inventoryManagement);
      var inventory = asNumber(option && option.dataset.inventoryQuantity);
      var label = stock.dataset.labelOut || 'אזל מהמלאי';
      stock.classList.remove('is-low', 'is-out');
      if (available) {
        label = stock.dataset.labelIn || 'במלאי';
        if (managed && inventory <= threshold) {
          label = (stock.dataset.labelLow || 'נותרו רק [qty] יחידות').replace('[qty]', inventory);
          stock.classList.add('is-low');
        }
      } else {
        stock.classList.add('is-out');
      }
      stockValue.textContent = label;
    }

    function renderPurchase(option) {
      var available = realStock(option);
      var unitPrice = asNumber(option && option.dataset.priceCents);
      var price = root.querySelector('[data-physical-price]');
      var compare = root.querySelector('[data-physical-compare]');
      var addPrice = root.querySelector('[data-physical-add-price]');
      var addLabel = root.querySelector('[data-physical-add-label]');
      var mobilePrice = root.querySelector('[data-physical-mobile-price]');
      var availableLabel = mainAdd ? mainAdd.dataset.labelAvailable : 'הוספה לעגלה';
      var unavailableLabel = mainAdd ? mainAdd.dataset.labelUnavailable : 'אזל מהמלאי';
      if (quantityInput) {
        var inventory = asNumber(option && option.dataset.inventoryQuantity);
        quantityInput.max = option && option.dataset.inventoryManagement && available ? String(Math.max(1, inventory)) : '99';
      }
      var total = unitPrice * quantity();
      if (price && option) price.textContent = option.dataset.priceFormatted || formatMoney(unitPrice);
      if (compare) {
        var comparePrice = asNumber(option && option.dataset.compareAtCents);
        compare.hidden = !(comparePrice > unitPrice);
        compare.textContent = comparePrice > unitPrice ? (option.dataset.compareAtFormatted || formatMoney(comparePrice)) : '';
      }
      if (addPrice && option) addPrice.textContent = formatMoney(total);
      if (addLabel) addLabel.textContent = available ? availableLabel : unavailableLabel;
      if (mainAdd) mainAdd.disabled = !available;
      if (mobilePrice && option) mobilePrice.textContent = option.dataset.priceFormatted || formatMoney(unitPrice);
      if (mobileAdd) {
        mobileAdd.disabled = !available;
        mobileAdd.textContent = available ? availableLabel : unavailableLabel;
      }
      renderStock(option);
    }

    function updateBundleMain(option) {
      var bundle = root.querySelector('[data-physical-bundle]');
      if (!bundle || !option) return;
      var summary = bundle.querySelector('.physical-bundle-summary');
      var mainPrice = bundle.querySelector('[data-physical-bundle-main-price]');
      var mainTitle = bundle.querySelector('[data-physical-bundle-main-variant]');
      if (summary) {
        summary.dataset.mainVariantId = option.value;
        summary.dataset.mainPriceCents = option.dataset.priceCents || '0';
      }
      if (mainPrice) setBundlePrice(mainPrice, option.dataset.priceFormatted || formatMoney(asNumber(option.dataset.priceCents)));
      if (mainTitle) mainTitle.textContent = option.dataset.title || '';
      renderBundleSummary(bundle);
    }

    function setUnavailableSelection() {
      activeVariant = null;
      renderPurchase(null);
      setFeedback(feedback, 'יש לבחור שילוב אפשרויות זמין לפני ההוספה לעגלה.', true);
    }

    function applyVariant(option, updateUrl) {
      if (!option) {
        setUnavailableSelection();
        return;
      }
      activeVariant = option;
      variantSelect.value = option.value;
      syncSelectedValues(option);
      renderOptionState();
      renderOptionAvailability();
      renderPurchase(option);
      showMedia(option.dataset.featuredMediaId);
      updateBundleMain(option);
      setFeedback(feedback, '', false);
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      root.dispatchEvent(new CustomEvent('physical:variant-change', { detail: { variantId: option.value } }));
      if (updateUrl && window.history && window.URL) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (activeVariant) syncSelectedValues(activeVariant);
    renderOptionState();
    renderOptionAvailability();
    renderPurchase(activeVariant);

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        selectedValues[asNumber(button.dataset.optionPosition) - 1] = button.dataset.optionValue;
        renderOptionState();
        renderOptionAvailability();
        var option = exactVariant(true);
        if (option) applyVariant(option, true);
        else setUnavailableSelection();
      });
    });

    var minus = root.querySelector('[data-physical-qty-minus]');
    var plus = root.querySelector('[data-physical-qty-plus]');
    if (minus) minus.addEventListener('click', function () { if (quantityInput) quantityInput.value = String(quantity() - 1); quantity(); renderPurchase(activeVariant); if (bundle) renderBundleSummary(bundle); });
    if (plus) plus.addEventListener('click', function () { if (quantityInput) quantityInput.value = String(quantity() + 1); quantity(); renderPurchase(activeVariant); if (bundle) renderBundleSummary(bundle); });
    if (quantityInput) {
      quantityInput.addEventListener('change', function () { quantity(); renderPurchase(activeVariant); if (bundle) renderBundleSummary(bundle); });
      quantityInput.addEventListener('input', function () { renderPurchase(activeVariant); if (bundle) renderBundleSummary(bundle); });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!activeVariant || !realStock(activeVariant)) {
          event.preventDefault();
          setFeedback(feedback, 'האפשרות שנבחרה אינה זמינה. יש לבחור אפשרות במלאי.', true);
          return;
        }
        if (!window.MvcCart || typeof window.MvcCart.addForm !== 'function') return;
        event.preventDefault();
        var source = event.submitter || mainAdd;
        setFeedback(feedback, 'מוסיפים לעגלה…', false);
        window.MvcCart.addForm(form, { source: source, open: true, singleCopy: root.hasAttribute('data-digital-pattern'), successMessage: 'המוצר נוסף לעגלה.' })
          .then(function () { setFeedback(feedback, '', false); })
          .catch(function (error) { setFeedback(feedback, cartError(error), true); });
      });
    }

    function selectedBundleItems(bundle) {
      var summary = bundle.querySelector('.physical-bundle-summary');
      var items = [];
      if (summary && activeVariant && realStock(activeVariant)) {
        items.push({ id: Number(activeVariant.value), quantity: quantity(), title: document.title, price: asNumber(activeVariant.dataset.priceCents) });
      }
      queryAll(bundle, '[data-physical-bundle-item]').forEach(function (row) {
        var check = row.querySelector('[data-physical-bundle-check]');
        if (!check || !check.checked) return;
        var hidden = row.querySelector('[data-physical-bundle-variant]');
        var select = row.querySelector('[data-physical-bundle-select]');
        var option = select && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
        var id = hidden ? hidden.value : (option ? option.value : '');
        if (!id) return;
        var titleNode = row.querySelector('.physical-bundle-copy b');
        items.push({ id: Number(id), quantity: 1, title: titleNode ? titleNode.textContent.trim() : '', price: hidden ? asNumber(hidden.dataset.priceCents) : asNumber(option.dataset.priceCents) });
      });
      return items;
    }

    function setBundlePrice(node, value) {
      if (!node) return;
      var isolated = node.querySelector('bdi');
      if (!isolated) {
        isolated = document.createElement('bdi');
        node.textContent = '';
        node.appendChild(isolated);
      }
      isolated.textContent = value;
    }

    function renderBundleSummary(bundle) {
      if (!bundle) return;
      var lines = bundle.querySelector('[data-physical-bundle-summary-lines]');
      var totalNode = bundle.querySelector('[data-physical-bundle-total]');
      if (!lines || !totalNode) return;
      var items = selectedBundleItems(bundle);
      lines.textContent = '';
      var total = 0;
      items.forEach(function (item, index) {
        var line = document.createElement('div');
        var title = document.createElement('span');
        var price = document.createElement('bdi');
        line.className = 'physical-bundle-summary-line';
        title.className = 'physical-bundle-summary-title';
        title.setAttribute('dir', 'auto');
        price.className = 'physical-bundle-summary-price physical-num';
        title.textContent = index === 0 ? 'המוצר הנוכחי' : item.title;
        price.textContent = formatMoney(item.price * item.quantity);
        line.appendChild(title);
        line.appendChild(price);
        lines.appendChild(line);
        total += item.price * item.quantity;
      });
      setBundlePrice(totalNode, formatMoney(total));
    }

    var bundle = root.querySelector('[data-physical-bundle]');
    if (bundle) {
      queryAll(bundle, '[data-physical-bundle-check]').forEach(function (check) {
        check.addEventListener('change', function () { renderBundleSummary(bundle); });
      });
      queryAll(bundle, '[data-physical-bundle-select]').forEach(function (select) {
        select.addEventListener('change', function () {
          var row = select.closest('[data-physical-bundle-item]');
          var check = row && row.querySelector('[data-physical-bundle-check]');
          var rowPrice = row && row.querySelector('[data-physical-bundle-row-price]');
          var option = select.options[select.selectedIndex];
          if (check && option.value) check.checked = true;
          if (rowPrice && option.value) setBundlePrice(rowPrice, option.dataset.priceFormatted || formatMoney(asNumber(option.dataset.priceCents)));
          renderBundleSummary(bundle);
        });
      });
      renderBundleSummary(bundle);
      var bundleAdd = bundle.querySelector('[data-physical-bundle-add]');
      var bundleFeedback = bundle.querySelector('[data-physical-bundle-feedback]');
      if (bundleAdd) {
        bundleAdd.addEventListener('click', function () {
          if (!activeVariant || !realStock(activeVariant)) {
            setFeedback(bundleFeedback, 'יש לבחור אפשרות זמינה למוצר הנוכחי.', true);
            return;
          }
          var missingSelection = queryAll(bundle, '[data-physical-bundle-item]').some(function (row) {
            var check = row.querySelector('[data-physical-bundle-check]');
            var select = row.querySelector('[data-physical-bundle-select]');
            return check && check.checked && select && !select.value;
          });
          if (missingSelection) {
            setFeedback(bundleFeedback, 'יש לבחור אפשרות לכל מוצר מסומן.', true);
            return;
          }
          var items = selectedBundleItems(bundle).map(function (item) { return { id: item.id, quantity: item.quantity }; });
          if (!window.MvcCart || typeof window.MvcCart.addItems !== 'function') {
            setFeedback(bundleFeedback, 'העגלה אינה זמינה כרגע. נסו שוב.', true);
            return;
          }
          setFeedback(bundleFeedback, 'מוסיפים את הסט לעגלה…', false);
          window.MvcCart.addItems(items, { source: bundleAdd, open: true, successMessage: 'הסט נוסף לעגלה.' })
            .then(function () { setFeedback(bundleFeedback, 'הסט נוסף לעגלה.', false); })
            .catch(function (error) { setFeedback(bundleFeedback, cartError(error), true); });
        });
      }
    }

    queryAll(root, '[data-physical-accordion]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        var opening = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', opening ? 'true' : 'false');
        panel.hidden = !opening;
      });
    });

    var guide = root.querySelector('[data-physical-guide]');
    var guideOpen = root.querySelector('[data-physical-guide-open]');
    var lastFocus = null;
    function closeGuide() {
      if (!guide || guide.hidden) return;
      guide.hidden = true;
      document.documentElement.style.removeProperty('overflow');
      if (lastFocus) lastFocus.focus();
    }
    if (guide && guideOpen) {
      guideOpen.addEventListener('click', function () {
        lastFocus = document.activeElement;
        guide.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        var close = guide.querySelector('[data-physical-guide-close]:not(.physical-guide-backdrop)');
        if (close) close.focus();
      });
      queryAll(guide, '[data-physical-guide-close]').forEach(function (button) { button.addEventListener('click', closeGuide); });
      var handleGuideKeys = function (event) {
        if (guide.hidden) return;
        if (event.key === 'Escape') {
          closeGuide();
          return;
        }
        if (event.key !== 'Tab') return;
        var focusable = queryAll(guide, 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      };
      document.addEventListener('keydown', handleGuideKeys);
      cleanupTasks.push(function () { document.removeEventListener('keydown', handleGuideKeys); document.documentElement.style.removeProperty('overflow'); });
    }

    function bindRelated(container) {
      queryAll(container, '[data-physical-related-add]').forEach(function (button) {
        if (button.dataset.physicalBound === 'true') return;
        button.dataset.physicalBound = 'true';
        button.addEventListener('click', function () {
          var relatedSection = button.closest('[data-physical-related-section]');
          var relatedFeedback = relatedSection && relatedSection.querySelector('[data-physical-related-feedback]');
          if (!window.MvcCart || typeof window.MvcCart.addItems !== 'function') {
            setFeedback(relatedFeedback, 'העגלה אינה זמינה כרגע. נסו שוב.', true);
            return;
          }
          setFeedback(relatedFeedback, 'מוסיפים לעגלה…', false);
          window.MvcCart.addItems([{ id: Number(button.dataset.variantId), quantity: 1 }], { source: button, open: true, successMessage: 'המוצר נוסף לעגלה.' })
            .then(function () { setFeedback(relatedFeedback, 'המוצר נוסף לעגלה.', false); })
            .catch(function (error) { setFeedback(relatedFeedback, cartError(error), true); });
        });
      });
    }

    var related = root.querySelector('[data-physical-related-section]');
    if (related) {
      bindRelated(related);
      if (related.dataset.manualRelated !== 'true' && related.dataset.recommendationsPerformed !== 'true' && related.dataset.recommendationsUrl && window.fetch) {
        fetch(related.dataset.recommendationsUrl, { credentials: 'same-origin' })
          .then(function (response) { if (!response.ok) throw new Error('recommendations_failed'); return response.text(); })
          .then(function (markup) {
            var documentNode = new DOMParser().parseFromString(markup, 'text/html');
            var replacement = documentNode.querySelector('[data-physical-related-section]');
            var replacementGrid = replacement && replacement.querySelector('[data-physical-related-grid]');
            var currentGrid = related.querySelector('[data-physical-related-grid]');
            if (!replacementGrid || !replacementGrid.children.length || !currentGrid) return;
            currentGrid.innerHTML = replacementGrid.innerHTML;
            related.hidden = false;
            related.dataset.recommendationsPerformed = 'true';
            bindRelated(related);
          })
          .catch(function () { /* Manual fallback remains intact. */ });
      }
    }

    var mobileBar = root.querySelector('[data-physical-mobile-bar]');
    var buyRow = root.querySelector('[data-physical-buy-row]');
    if (mobileBar && buyRow && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        mobileBar.classList.toggle('is-suppressed', entries[0].isIntersecting);
      }, { threshold: 0.2 });
      observer.observe(buyRow);
      cleanupTasks.push(function () { observer.disconnect(); });
    }

    cleanups.set(root, function () {
      cleanupTasks.forEach(function (task) { task(); });
      cleanups.delete(root);
    });
  }

  function initScope(scope) {
    if (scope.matches && scope.matches('[data-physical-product]')) initPhysical(scope);
    queryAll(scope, '[data-physical-product]').forEach(initPhysical);
  }

  window.MvcPhysicalProduct = { initScope: initScope };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initScope(document); }, { once: true });
  } else {
    initScope(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initScope(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches('[data-physical-product]') ? event.target : event.target.querySelector('[data-physical-product]');
    var cleanup = root && cleanups.get(root);
    if (cleanup) cleanup();
  });
  document.addEventListener('shopify:block:select', function (event) {
    if (!event.target.closest || !event.target.closest('[data-physical-product]')) return;
    event.target.scrollIntoView({ block: 'center', behavior: reducedMotion ? 'auto' : 'smooth' });
  });
})();
